import React, { useEffect, useState } from "react";
import { Container, Table, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Footer from "../../../components/superAdmin/footer/Footer";
import SubAdminHeader from "../components/SubAdminHeader";

const SubAdminDashboard = () => {
    const navigate = useNavigate();
    const [permissions, setPermissions] = useState(null);
    const [counts, setCounts] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = "JAS Jaipur - Sub Admin";
        
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('jff_token');
                const [permRes, countRes] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_API_END_POINT}/subadmin/dashboard`, { headers: { token } }),
                    axios.get(`${process.env.REACT_APP_API_END_POINT}/subadmin/counts`, { headers: { token } })
                ]);
                
                setPermissions(permRes.data.permissions);
                setCounts(countRes.data.data);
                
                // Also store permissions in localStorage for the Navbar to use
                localStorage.setItem('subAdminPermissions', JSON.stringify(permRes.data.permissions));
            } catch (error) {
                console.error("Error fetching dashboard data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" variant="warning" />
                <p className="mt-2">Loading Dashboard...</p>
            </div>
        );
    }

    if (!permissions || Object.keys(permissions).length === 0) {
        return (
            <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
                <SubAdminHeader />
                <Container className="py-5 text-center">
                    <div style={{ fontSize: '64px', marginBottom: '20px' }}>🔒</div>
                    <h3 style={{ color: '#b98b51' }}>No access has been granted yet.</h3>
                    <p className="text-muted">Please contact your administrator.</p>
                </Container>
                <Footer />
            </div>
        );
    }

    const renderCountTable = (title, columns) => {
        // Only show if at least one column is enabled
        const enabledCols = columns.filter(col => col.enabled);
        if (enabledCols.length === 0) return null;

        return (
            <div className="col-lg-12">
                <div className="p-3 border">
                    <p className="fw-bold fs-4 my-1">{title}</p>
                    <div className="container text-center my-2">
                        <div className="row" style={{ backgroundColor: "#b98b51" }}>
                            {enabledCols.map((col, idx) => (
                                <div key={idx} className="col border border-white text-white py-1">
                                    {col.label}
                                </div>
                            ))}
                        </div>
                        <div className="row" style={{ backgroundColor: "#f6e5cf" }}>
                            {enabledCols.map((col, idx) => (
                                <div 
                                    key={idx} 
                                    className="col border border-white" 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => navigate(col.path)}
                                >
                                    {counts[col.key] || 0}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
            <SubAdminHeader />

            <div className="content-height">
                <div className="text-center">
                    <h2 className="form-heading">Sub-Admin DashBoard</h2>
                </div>

                <div className="container text-center my-2">
                    <div className="mb-5 p-5">
                        <div className="row" style={{ gap: "20px 0px" }}>
                            {/* Area Section */}
                            {renderCountTable("Area", [
                                { label: "All Areas", key: "areas", path: "/subadmin/areas", enabled: permissions.areaList?.enabled }
                            ])}

                            {/* Hosted Buyer Section */}
                            {renderCountTable("Hosted Buyer", [
                                { label: "Buyer Requests", key: "buyerRequests", path: "/subadmin/buyers/requests", enabled: permissions.buyersList?.buyersRequestList?.enabled },
                                { label: "Invited Buyers", key: "buyerInvited", path: "/subadmin/buyers/invited", enabled: permissions.buyersList?.buyersInvitedList?.enabled },
                                { label: "Recycled Buyers", key: "buyerRecycled", path: "/subadmin/buyers/recycled", enabled: permissions.buyersList?.buyersHostedRecycledList?.enabled },
                                { label: "Old Buyers", key: "buyerOld", path: "/subadmin/buyers/old", enabled: permissions.buyersList?.buyersOldList?.enabled }
                            ])}

                            {/* Visitor Section */}
                            {renderCountTable("Visitor", [
                                { label: "Registered", key: "visitors", path: "/subadmin/visitors", enabled: permissions.visitorsList?.enabled }
                            ])}

                            {/* Exhibitor Section */}
                            {renderCountTable("Exhibitor", [
                                { label: "All Exhibitors", key: "exhibitors", path: "/subadmin/exhibitors", enabled: permissions.exhibitorList?.enabled }
                            ])}
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default SubAdminDashboard;
